var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSponsorLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 60,
    viewBox: "0 0 159 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.25 59.4669H158.733V0.579102H0.25V59.4669ZM2.95386 3.27467H156.037V56.7381H2.95386V3.27467Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6739 15.9648V43.9987L44.8718 44.289V45.9312H33.9817V44.289L36.329 43.9987V31.2424H22.4198V43.9987L24.568 44.289V45.9312H13.877V44.289L16.0251 43.9987V15.9648L13.877 15.6745V14.082H24.568V15.6745L22.4198 15.9648V27.9497H36.329V15.9648L33.9817 15.6745V14.082H44.8718V15.6745L42.6739 15.9648Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5123 44.1979L59.561 44.4881V45.9313H49.5583V44.4881L51.607 44.1979V25.0054L49.5583 24.7151V23.2637H57.5123V44.1979Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.907 44.5295L65.9059 44.2475V15.7657L63.907 15.4837V14.082H71.861V44.2475L73.9096 44.5295V45.9312H63.907V44.5295Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0601 23.2638H91.4264V25.3871H86.0601V38.8732C86.0601 42.3567 86.79 43.4681 89.9666 43.4681C91.0286 43.5151 92.0923 43.4343 93.1349 43.2276V44.7703C90.7782 45.6587 88.2879 46.1411 85.7698 46.1968C81.1832 46.1968 80.105 44.1233 80.105 40.1588V25.3871H75.9082V23.2638H80.2543V18.5279L86.0601 16.7861V23.2638Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.78 34.6675C111.78 27.518 109.632 24.3746 106.165 24.3746C102.698 24.3746 100.649 27.3687 100.649 34.6675C100.649 41.9662 102.798 44.8692 106.165 44.8692C109.781 44.8692 111.78 42.016 111.78 34.6675ZM118.324 34.8168C118.324 41.875 113.538 46.6109 106.024 46.6109C98.7501 46.6109 94.1138 43.5172 94.1138 34.8168C94.1138 27.518 98.8994 22.6328 106.414 22.6328C113.928 22.6328 118.324 27.037 118.324 34.8168Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.454 44.48V45.9314H135.443V44.48L137.442 44.198V31.2676C137.442 27.6928 136.131 26.1004 133.394 26.1004C131.68 26.3122 130.05 26.9605 128.658 27.9831V44.198L130.707 44.48V45.9314H120.663V44.48L122.711 44.198V25.1217L120.663 24.8314V23.2638H128.667V26.4072C131.155 24.425 133.544 22.8242 136.911 22.8242C141.406 22.8242 143.405 25.4368 143.405 30.5626V44.198L145.454 44.48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8024 17.267C57.8106 17.9068 57.6284 18.5346 57.2789 19.0706C56.9294 19.6066 56.4284 20.0266 55.8397 20.2772C55.2509 20.5278 54.6009 20.5976 53.9723 20.4778C53.3438 20.3581 52.765 20.0541 52.3096 19.6046C51.8543 19.155 51.5428 18.5803 51.415 17.9533C51.2871 17.3263 51.3485 16.6755 51.5914 16.0835C51.8344 15.4916 52.2478 14.9852 52.7793 14.6288C53.3107 14.2724 53.9361 14.0821 54.576 14.0821C55.4258 14.0777 56.2428 14.4105 56.8476 15.0075C57.4524 15.6046 57.7958 16.4171 57.8024 17.267Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 158.5,
    height: 58.8962,
    fill: "white",
    transform: "translate(0.25 0.579102)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSponsorLogo);
export default __webpack_public_path__ + "static/media/sponsorLogo.ee446db3a3238d6da76b41245081c2b6.svg";
export { ForwardRef as ReactComponent };